<header class="pretty-easy-navigation__header">
    @if (!isSidebarFolded()) {
        <a class="pretty-easy-navigation__home-link"
           id="main_logo_link"
           appFocusBoundary
           [prevId]="'skiptocontent_link'"
           [nextId]="'togglemenutabgestion'"
           role="link"
           tabindex="0"
           (keydown.enter)="navigate()"
           (click)="navigate()"
           [attr.aria-label]="brand + ' accueil'"
           aria-hidden="false">
            @if (brandLogoSvg) {
                <mat-icon class="pretty-easy-navigation__logo-icon"
                          svgIcon="pretty-easy-navigation__logo"
                          aria-hidden="true">
                </mat-icon>
            } @else {
                <img class="pretty-easy-navigation__logo-image"
                     src="assets/{{ brand }}/images/logos/brand.png"
                     [alt]="brand"
                     aria-hidden="true"/>
            }
        </a>
    }
    <!-- Close menu button displayed on mobile -->
    <button class="pretty-easy-navigation__close-menu-button"
            data-e2e="pretty-easy-navigation-close-menu"
            [attr.aria-label]="'navigation.close_menu' | translate"
            [matTooltip]="'navigation.close_menu' | translate"
            matTooltipPosition="right"
            (click)="closeSidebar()">
        <mat-icon svgIcon="pretty-easy-navigation__close-menu"></mat-icon>
    </button>
    <!-- Toggle menu button displayed on desktop -->
    <button class="pretty-easy-navigation__toggle-menu-button"
            id="togglemenutabgestion"
            tabindex="0"
            data-e2e="pretty-easy-navigation-toggle-menu"
            [attr.aria-label]="isSidebarFolded() ? ('generic.menu_unfold' | translate) : ('generic.menu_fold' | translate)"
            [attr.aria-expanded]="!isSidebarFolded()"
            aria-controls="navbar"
            [matTooltip]="isSidebarFolded() ? ('generic.menu_unfold' | translate) : ('generic.menu_fold' | translate)"
            matTooltipPosition="right"
            (click)="toggleSidebarFolded()">
        <mat-icon svgIcon="pretty-easy-navigation__toggle-menu"></mat-icon>
    </button>
</header>

<nav class="pretty-easy-navigation__nav"
     fusePerfectScrollbar>
    <ul class="pretty-easy-navigation__list" id="mainmenuelem">
        @for (menuSlot of menu(); track menuSlot) {
            <li class="pretty-easy-navigation__list-item">
                @switch (menuSlot.type) {
                    @case ('linkGroup') {
                        <app-pretty-easy-link-group [slot]="menuSlot"
                                                    [isSidebarFolded]="isSidebarFolded()"
                                                    [unfoldSidebar]="unfoldSidebar.bind(this)">
                        </app-pretty-easy-link-group>
                    }
                    @case ('accordionLinkGroup') {
                        <app-pretty-easy-accordion-link-group [slot]="menuSlot"
                                                              [isSidebarFolded]="isSidebarFolded()"
                                                              [unfoldSidebar]="unfoldSidebar.bind(this)">
                        </app-pretty-easy-accordion-link-group>
                    }
                    @case ('link') {
                        <app-pretty-easy-link [linkData]="menuSlot"
                                              [isSidebarFolded]="isSidebarFolded()">
                        </app-pretty-easy-link>
                    }
                    @case ('actionLink') {
                        <app-pretty-easy-link [linkData]="menuSlot"
                                              [isSidebarFolded]="isSidebarFolded()">
                        </app-pretty-easy-link>
                    }
                    @case ('imageLink') {
                        <app-pretty-easy-image-link [linkData]="menuSlot"
                                                    [isSidebarFolded]="isSidebarFolded">
                        </app-pretty-easy-image-link>
                    }
                }
            </li>
        }
    </ul>
</nav>
